<div class="admin-container">
  <h2>Administración de Categorías de Academy</h2>
  
  <div class="actions-top">
    <button (click)="create()" class="btn-add">Nuevo</button>
  </div>
  
  <div class="table-container" *ngIf="!selected">
    <div class="loader" *ngIf="loading">Cargando...</div>
    
    <table *ngIf="!loading && data && data.length > 0">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>{{ item.name }}</td>
          <td class="actions-column">
            <button (click)="edit(item)" class="btn-edit">Editar</button>
            <button (click)="delete(item)" class="btn-delete">Eliminar</button>
          </td>
        </tr>
      </tbody>
    </table>
    
    <div class="empty-state" *ngIf="!loading && (!data || data.length === 0)">
      No hay categorías definidas. Haga clic en "Nuevo" para crear uno.
    </div>
  </div>
  
  <form #form="ngForm">
    <div class="role-form" *ngIf="selected">
      <h2>{{ isNew ? 'Crear Categoría' : 'Editar Categoría' }}</h2>

      <div class="form-group">
        <label>Nombre:</label>
        <input #name="ngModel" type="text" [(ngModel)]="selected.name" required name="name"/>
        <div [hidden]="name.valid || name.pristine"
             class="validation-error">
          Ingresar Nombre
        </div>
      </div>
      
      <div class="actions">
        <button (click)="save()" class="btn-save" [disabled]="!form.form.valid">Guardar</button>
        <button (click)="cancelEdit()" class="btn-cancel">Cancelar</button>
      </div>
    </div>
  </form>
</div> 